import { createSlice } from "@reduxjs/toolkit";

const editSlice = createSlice({
  initialState: {
    property: {},
  },
  name: "edit",
  reducers: {
    setProperty: (state, action) => {
      state.property = action.payload;
    },
  },
});

export const ediiActions = editSlice.actions;
export default editSlice;
